export default __webpack_public_path__ + "static/media/0022.6158246e.png";